// Auto-generated normalizer for table: Empleados_Puesto
export function empleadosPuestoNormalize(row) {
  return {
    idEmpleadoPuesto: row.idEmpleadoPuesto ?? row.IdEmpleadoPuesto ?? row['IdEmpleadoPuesto'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['IdEmpleado'] ?? 0,
    idPuesto: row.idPuesto ?? row.IdPuesto ?? row['IdPuesto'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaAsignacion: row.fechaAsignacion ?? row.FechaAsignacion ?? row['FechaAsignacion'] ?? null,
  };
}
